import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, Checkbox, CircularProgress, Container, FormControlLabel, Grid, TextField} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import {ShipToService} from '../../../services';

const ShipToMappingForm = () => {
    const methods = useForm();
    const {handleSubmit, control} = methods;

    const [data, setData] = useState({});
    const {showMessage, showError} = useContext(NotificationContext);
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [isChecked, setIsChecked] = useState(false);
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
    const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `integrations/shipToMapping/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

      useEffect(() => {      
        ShipToService.detailGet(id)
        .then((response) => {
            setData(response.data)
            setIsChecked(response.data.isInvalid);
           setIsReady(true); 
        })                  
           }, []);


    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        ShipToService.detailUpdate({...data, ...d}).then((response) => {
                showMessage('Ship-to mapped.');
            }).catch((err) => {
                showError(err.message);
            });              
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     

      const checkHandler = () => {     
        setIsChecked(!isChecked)  
        setData({...data, isInvalid: !isChecked})
      }
   
      const onSave = (event) => {
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }

              return (
                <Container>
                    <header>
                        <h1>Ship-to Mapping Form</h1>
                    </header>
        
                    <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
                    <Prompt
                       visible={isVisibleDialog}
                       onClose={() => setVisibleDialog(false)}
                       onOk={() => {
                       setTriggerExit({...triggerExit, onOk: true});
                       setVisibleDialog(false);
                       setBlock(false);
                    }}
                       onSave={onSave}
                    />
                        <Grid container>
                        <Grid item xs={5} m={2}>
                        <Controller
                            name="recipientRefCode"
                            control={control}
                            fullWidth
                            as={<TextField/>}
                            label="Wambo Recipient Ref Code"
                            disabled
                            color="primary"
                            variant="outlined"
                            defaultValue={data.recipientRefCode}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="clientName"
                            control={control}
                            fullWidth
                            label="Client Name"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.clientName}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="wamboShipToRefCode"
                            control={control}
                            fullWidth
                            label="Wambo Ship To Ref Code"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.wamboShipToRefCode}
                        />
                    </Grid>               

                    <Grid item xs={5} m={2}>

                        <Controller
                            name="shipToAddress"
                            control={control}
                            label="Ship To Address"
                            fullWidth
                            color="primary"
                            as={<TextField/>}
                            disabled
                            variant="outlined"
                            defaultValue={data.shipToAddress}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="orgID"
                            control={control}
                            fullWidth
                            as={<TextField/>}
                            label="Organization Id"
                            disabled
                            color="primary"
                            variant="outlined"
                            defaultValue={data.orgID}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="enterpriseId"
                            control={control}
                            fullWidth
                            label="Enterprise Id"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.enterpriseId}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                       <Controller
                           name="oneNetAddressName"
                           control={control}
                           label="One Net Address Name"
                           fullWidth
                           color="primary"
                           as={<TextField/>}
                           disabled
                           variant="outlined"
                           defaultValue={data.oneNetAddressName}
                       />
                       </Grid>   

                    <Grid item xs={5} m={2}>

                        <Controller
                            name="lastUpdated"
                            control={control}
                            label="Last Update"
                            fullWidth
                            color="primary"
                            as={<TextField/>}
                            disabled
                            variant="outlined"
                            defaultValue={data.lastUpdated}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                       <Controller
                           name="lastUpdatedBy"
                           control={control}
                           label="Last Updated By"
                           fullWidth
                           color="primary"
                           as={<TextField/>}
                           disabled
                           variant="outlined"
                           defaultValue={data.lastUpdatedBy}
                       />
                       </Grid>    
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="oneNetShipToCode"
                            fullWidth
                            control={control}
                            label="OneNet Ship To Code"
                            color="primary"
                            as={<TextField/>}
                            variant="outlined"
                            defaultValue={data.oneNetShipToCode}
                        />                    
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="notes"
                            fullWidth
                            control={control}
                            label="Type Note here"
                            color="primary"
                            as={<TextField
                            multiline
                            rows={3}
                            maxRows={6}/>}
                            variant="outlined"
                            defaultValue={data.notes}
                        />                    
                    </Grid>
                      <Grid item xs={5} m={2}>
                              <FormControlLabel sx={{ m: 1}} control={<Checkbox
                                       checked={isChecked}
                                       onChange={checkHandler}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                     /> } label="Invalid" />   
                    </Grid>
                     <Grid xs={12} m={2}>
                     <Button variant="contained" color="primary" type="submit">Update</Button>
                     </Grid>                                          
                        </Grid>
                        <button hidden={true} ref={refSubmitButtom} type={"submit"} />
                    </form>
        
        
                </Container>
            );

}

export default ShipToMappingForm;